import { Navigate, Route, Routes } from 'react-router-dom';
import { DirectoryLayout } from '@/components/Layout/DirectoryLayout';
import { ClubsPage } from '@/pages/ClubsPage';

export function App() {
  return (
    <Routes>
      <Route element={<DirectoryLayout />}>
        <Route index element={<ClubsPage />} />
        <Route path="clubs" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}
